export const orgBudget = {
  header: 'Tous les budgets ({{count}})',
  code: 'Code',
  name: 'Nom',
  active: 'Statut',
  currency: 'Devise',
  amount: 'Montant',
  unit: 'Unité',
  businessUnits: 'Unité',
  dateRange: 'Début - Fin',
  startDate: 'Début',
  endDate: 'Fin',
  actions: '',
  sortBy: 'Trier par',
  sort: {
    byName: 'Nom',
    byUnitName: 'Unité',
    byCode: 'Code',
    byValue: 'Valeur',
  },
  hint: 'Les budgets définissent les limites globales d\'achat et sont assignés aux centres de coûts. Un acheteur sélectionne un centre de coûts lors du passage à la caisse.',
  details: {
    title: 'Détails du budget',
    subtitle: 'Budget : {{ item.name }}',
  },
  edit: {
    title: 'Modifier le budget',
    subtitle: 'Budget : {{ item.name }}',
  },
  create: {
    title: 'Créer un budget',
    subtitle: '',
  },
  messages: {
    deactivateTitle: 'Désactiver ce budget?',
    deactivate: 'Les budgets désactivés ne s\'appliquent plus aux centres de coûts auxquels ils sont assignés. Assurez-vous que le centre de coûts associé dispose d\'au moins un budget.',
    confirmEnabled: 'Budget {{ item.name }} activé avec succès',
    confirmDisabled: 'Budget {{ item.name }} désactivé avec succès',
    update: 'Budget {{ item.name }} mis à jour avec succès',
    create: 'Budget {{ item.name }} créé avec succès',
  },
  info: {
    disabledEdit: 'Activez le budget pour permettre la modification.',
    disabledEnable: 'L\'unité doit être activée avant que ce budget puisse être activé.',
  },
  links: {
    costCenters: 'Centres de coûts',
  },
  breadcrumbs: {
    list: 'Tous les budgets',
    details: '{{name}}',
  },
};

export const orgBudgetAssignedCostCenters = {
  title: 'Centres de coûts',
  subtitle: 'Budget : {{ item.name }}',
};
